const getBasicItemTypeHandler = require('./basic-item-type-handler');

function itemTypeHandler(typeName, options = {}) {
  const { requiredProperties = [] } = options;
  const basicOptions = {
    ...options,
    requiredProperties: [
      {
        property: 'create',
        type: 'function'
      },
      ...requiredProperties
    ]
  };
  return getBasicItemTypeHandler(typeName, basicOptions);
}

module.exports = itemTypeHandler;
